// extracted by mini-css-extract-plugin
export default {"backBtn":"BackButton_backBtn__UOErY","backTxt":"BackButton_backTxt__eSyqi"};